import { render, staticRenderFns } from "./chatMessanger.vue?vue&type=template&id=26f6d2e2"
import script from "./chatMessanger.vue?vue&type=script&lang=js"
export * from "./chatMessanger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports